import { Study } from './study.model';

export class FinancialAdjustmentFilter {
  startFY: number;
  endFY: number;
  study: Study;
  studyId: number;
  studySearchStrategyId: number;
  ratioIds: number[];
  vendorAccountStorageNames: string[];
}
